import { createPortal } from "react-dom";

const Portal = ({ children, element }) =>
  createPortal(children, element ?? document.body);

export default Portal;
